import { Link } from "@mna/react";
import GlobalExcelLogo from "assets/logo/GEFOOTERWHITE.png";
import i18next from "i18next";
import { Trans } from "react-i18next";
import Modal from "react-modal";
import i18n from "../../src/i18n";
import { backClick } from "../pages/find-care-options/questions/Single";
import {
	checkAndGetLocalStorageValue,
	checkUrlSearchParamsHas,
} from "../features/utils";
import { careOptions } from "../server/triage/constants";

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
	},
};

var isSymptomPriorityCalled,
	isRelatedSymptomsCalled = false;

function handlechange(languageCode, setState, value, event) {
	if (value) 
	{
		sessionStorage.setItem("isFirstTimeLoad", true);
		setState({
		showLangModal: true,
		languageCode: languageCode,
		});
  	} 
	else if (event.key === " " || event.key === "Enter" || event.key === "Spacebar") 
	{
		sessionStorage.setItem("isFirstTimeLoad", true);
		setState({
		showLangModal: true,
		languageCode: languageCode,
		});
    } 
	else 
	{
		event.stopPropagation();
		return;
    }
	document.documentElement.setAttribute('lang', languageCode);
}

function onLogoClick(state, history) {
	if (state.IsValidUser) {
		history.push({
			pathname: "/terms",
			search: "?organizationId=" + checkAndGetLocalStorageValue("orgid"),
		});
	} else {
		history.push("/terms");
	}
}

function toggleButton(state, actions, setState, history){

	try 
	{
		if (typeof window !== "undefined") {
			if (
				window.location.pathname === "/find-care-options/questions" || window.location.pathname === "/find-care-options/care-options"
			) {
				if (
					state.presentQuestionsSelected.length > 0 ||
					state.unknownQuestionsSelected.length > 0 ||
					state.absentQuestionsSelected.length > 0
				) {
					if (
						window.location.pathname === "/find-care-options/questions"
					) {
						backClick({ state, actions, setState, history });
						state.triageRequest.activeMenu = "questions"
					}else if(window.location.pathname === "/find-care-options/care-options" && localStorage.getItem('careoption') === ''){
						 history.goBack();
						 isSymptomPriorityCalled = false;
						 isRelatedSymptomsCalled = false;
					}else{
						history.push("/find-care-options/questions")
					}
				} else {
					if (
						window.location.pathname ===
						"/find-care-options/questions"
					) {
						if (state.RelatedSymptomInfo.length > 0) {
							isSymptomPriorityCalled = false;
							isRelatedSymptomsCalled = true;
							state.triageRequest.activeMenu = "related-symptoms"
							history.replace(
								"/find-care-options/related-symptoms"
							);
						} else if (state.isTravelAid2 && state.triageRequest.activeMenu == "care-options") {
							history.replace(
								"/find-care-options/patientdetails-confo-screen"
							);
							history.push("/find-care-options/patientdetails-confo-screen")
						}
						else {
							isSymptomPriorityCalled = true;
							isRelatedSymptomsCalled = false;
							history.replace(
								"/find-care-options/symptom-priority"
							);
							state.triageRequest.activeMenu = "symptoms"
						}
					}
					else {
						if (
							isSymptomPriorityCalled ||
							isRelatedSymptomsCalled
						) {
							if(window.location.href.endsWith('#')) {
								history.go(-2)
							} else {
								history.goBack();
							}
						}
						isSymptomPriorityCalled = false;
						isRelatedSymptomsCalled = false;
						if(window.location.href.endsWith('#')) {
							history.go(-2)
						} else {
							history.goBack();
						}
					}
				}
			} else if (!state.triageRequest.isFacilitySearch && state.isTravelAid2 && checkAndGetLocalStorageValue("IsEmergencySelected") !== "true" && (window.location.pathname == "/find-care-options/symptoms" || window.location.pathname == "/find-care-options/patientdetails-confo-screen" || window.location.pathname == "/find-care-options/send-information" || window.location.pathname == "/find-care-options/emergency" || window.location.pathname == "/find-care-options/location") || window.location.pathname == "/find-care-options") {				if (window.location.pathname == "/find-care-options/symptoms") {
					history.push("/find-care-options/patientdetails-confo-screen");
					state.triageRequest.activeMenu = "start";
				} else if (window.location.pathname == "/find-care-options/patientdetails-confo-screen") {
					history.push("/find-care-options/send-information")
					state.triageRequest.activeMenu = "start";
				} else if (window.location.pathname == "/find-care-options/send-information" && checkAndGetLocalStorageValue("IsEmergencySelected") == "true") {
					history.push("/find-care-options/emergency");
					state.triageRequest.activeMenu = "care-options";
				}
				else if (window.location.pathname == "/find-care-options/send-information" || window.location.pathname == "/find-care-options/emergency") {
					history.push("/find-care-options/location")
					state.triageRequest.activeMenu = "location";
				}
				else if (window.location.pathname == "/find-care-options/location") {
					history.push("/find-care-options");
				}
				else if (window.location.pathname == "/find-care-options") {
					var pathName= state.isTravelAid2 ? "/triageNew" :  "/terms";
					var searchorg = state.IsValidUser || state.isTravelAid2 ? "?organizationId=" + checkAndGetLocalStorageValue("orgid") : "";
					history.push({
						pathname: pathName,
						search: searchorg,
					});
				} else {
					if(window.location.href.endsWith('#')) {
						history.go(-2)
					} else {
						history.goBack();
					}
					isSymptomPriorityCalled = false;
					isRelatedSymptomsCalled = false;
				}
				
			} else {
				if(window.location.href.endsWith('#')) {
					history.go(-2)
				} else {
					history.goBack();
				}
				isSymptomPriorityCalled = false;
				isRelatedSymptomsCalled = false;
			}
		}
	} 
	catch (e) 
	{
		isSymptomPriorityCalled = false;
		isRelatedSymptomsCalled = false;
		console.log("error", e);
	}
}

function clickBackButton(state, actions, setState, history) {
	toggleButton(state, actions, setState, history)
}


const HeaderTitle = ({
	backButtonTarget,
	backButtonStep,
	state,
	setState,
	actions,
	history,
}) => {
	if (backButtonTarget) {
		if (state.triageRequest.activeMenu == "confirm") {
			state.triageRequest.activeMenu = "start";
		} else if (state.triageRequest.activeMenu == "symptom-priority") {
			state.triageRequest.activeMenu =
				state.triageRequest.triageSymptom === "List"
					? "symptoms"
					: "NLPsymptom";
		} else if (state.triageRequest.activeMenu == "care-options-result") {
			state.triageRequest.activeMenu = "care-options";
		}
		// else if(state.triageRequest.activeMenu == "related-symptoms" && state.isTravelAid2){
		// 	state.triageRequest.activeMenu = "start";
		// }
	}
	return (
		<div className="header-logo" style={{ minHeight: "37px" }}>
			<div className="flex flex-center">
				{!backButtonTarget ? null : (
					<button
						className="header-back-button"
						tabIndex="0"
						type="button"
						aria-label={i18next.t("findcareoption.questions.Back")}
						onClick={() => {
							clickBackButton(state, actions, setState, history)		
						}}
					>
						<svg
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
							width="12"
							height="12"
							viewBox="0 0 1024 1024"
							role="img"
							aria-labelledby="svgBackBtn"
							alt={i18next.t("BackButton")}
							title={i18next.t("BackButton")}
						>
							<path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
						</svg>
					</button>
				)}

				<img
					src={GlobalExcelLogo}
					alt="Global Excel Logo"
					style={{ height: "30px", paddingRight: "11px" }}
				/>
			</div>
		</div>
	);
};

export default ({
	state,
	actions,
	setState,
	history,
	routeName,
	backButtonTarget,
	backButtonStep,
	isLoggedIn,
	isValid,
}) => {
	const routeBase = routeName.split("/")[0] || "";
	const layoutMap = {
		default: {
			title: (
				<HeaderTitle
					{...{
						backButtonTarget,
						backButtonStep,
						state,
						setState,
						actions,
						history,
					}}
				/>
			),
			center: (
				<div
					className="header-center-logo"
					onClick={() => {
						onLogoClick(state, history);
					}}
				>
					{state.base64 === undefined || state.IsValidUser || state.isFacility ? (
						""
					) : null
					}

				</div>
			),
		},
	};

	let data = layoutMap[routeBase]
		? {
			...layoutMap.default,
			...layoutMap[routeBase],
		}
		: {
			...layoutMap.default,
			items: [
				...(layoutMap.default.items || []),

				<div className="lang-menu-container">
					{routeBase !== "create-user" &&
						routeBase !== "create-primary" &&
						routeBase !== "create-profile" &&
						routeBase !== "create-details" && routeBase !== "" ? (
						<span className="dropdown-toggle headerMenu standby-info-card-view" id="divLang" >
							{" "}
							<a href="#"
								className={
									state.triageRequest.isLangShown
										? "lang-sel lang-expanded"
										: "lang-sel"
								}
								onClick={(e) => {
									state.triageRequest.isLangShown = !state.triageRequest
										.isLangShown;
									sessionStorage.setItem("contolBackButton", true);
								}} 
								role="button" 
								tabIndex="0" 
								aria-label={(state.defaultLanguageCode === "de" ? i18next.t("German") : state.defaultLanguageCode === "es" ? i18next.t("Spanish") : state.defaultLanguageCode === "fr" ? i18next.t("French") : i18next.t("English") )}
							>
								{" "}
								{i18next.t("language")}{" "}
							</a>
							{state.triageRequest.isLangShown && (
								<ul className="dropdown-menu" id="selectLanguage" style={{display:"block"}}>
									<li
										className="menu-bottom-border"
										value="en"
										key="en"
										onKeyDown={(event) => {
											handlechange("en", setState, false, event);}}
										onClick={(event) => {
											handlechange("en", setState, true);
										}}
									>
										<a href="#" role="button" tabIndex="0" aria-label={i18next.t("English")}>
											<Trans i18nKey="English">English</Trans>
										</a>
									</li>
									<li
										className="menu-bottom-border"
										value="fr"
										key="fr"
										onKeyDown={(event)=>{
											handlechange("fr", setState, false, event);
										}}
										onClick={(event) => {
											handlechange("fr", setState, true);
										}}
									>
										<a href="#" role="button" tabIndex="0" aria-label={i18next.t("French")}>
											<Trans i18nKey="French">Français</Trans>
										</a>
									</li>
									<li
										className="menu-bottom-border"
										value="es"
										key="es"
										onKeyDown={(event)=>{
											handlechange("es", setState, false, event);
										}}
										onClick={(event) => {
											handlechange("es", setState, true);
										}}
									>
										<a href="#" role="button" tabIndex="0" aria-label={i18next.t("Spanish")}>
											<Trans i18nKey="Spanish">Español</Trans>
										</a>
									</li>
									<li
										className="menu-bottom-border"
										value="de"
										key="de"
										onKeyDown={(event)=>{
											handlechange("de", setState, false, event);
										}}
										onClick={(event) => {
											handlechange("de", setState, true);
										}}
									>
										<a href="#" role="button" tabIndex="0" aria-label={i18next.t("German")}>
											<Trans i18nKey="German">Deutsch</Trans>
										</a>
									</li>
								</ul>
							)}
						</span>
					) : (
						""
					)}
				</div>,
				!routeBase.length ? (
					""
				) : (
					<div role="group" className="lang-menu-container headerMenu standby-info-card-view" id="divExitTriage">
						<a
							className="view-mode-toggle" 
							onClick={(e) => {
								if (state.IsValidUser || state.isFacility || state.isTriageGoingForRegularUser)
								{setState({
									showModal: true,
								});
								sessionStorage.setItem("contolBackButton", true);
							}
								else if(!state.isTriageGoingForRegularUser){
									setState({
										showModal: true,
									})
									sessionStorage.setItem("contolBackButton", true);
								}
							}}
							onKeyDown={(e)=>{
								if (e.key === " " || e.key === "Enter" || e.key === "Spacebar"){
									if (state.IsValidUser || state.isFacility || state.isTriageGoingForRegularUser)
								setState({
									showModal: true,
								});
								else if(!state.isTriageGoingForRegularUser){
									setState({
										showModal: true,
									})
								}
							}
							}}
							role="button" tabIndex="0"
							href="#"
						>
							{typeof window !== "undefined" ? state.IsValidUser || state.isTriageGoingForRegularUser || state.isFacility || state.isTravelAid2 || checkUrlSearchParamsHas(window.location.search) ? (
								<Trans i18nKey="ExitTriage">Exit Triage</Trans>
							) : routeBase !== "create-user" &&
								routeBase !== "create-primary" &&
								routeBase !== "create-profile" &&
								routeBase !== "create-details" ? (
								<Trans i18nKey="Home">Home</Trans>
							) : (
								<Trans i18nKey="ExitTriage">Exit Triage</Trans>
							):(
								<Trans i18nKey="ExitTriage">Exit Triage</Trans>
							)}
						</a>
						<Modal
							isOpen={state.showModal}
							contentLabel="customStyles"
							className="ReactModal__Content_triagepopup"
							overlayClassName="ReactModal__Overlay_triagepopup"
							role=""
						>
							<label className="confirm_title">
								{
									<Trans i18nKey="findcareoption.Careoptions.Please_confirm">
										Please confirm
									</Trans>
								}
							</label>
							<label>
								{
									!state.isTriageGoingForRegularUser && !state.IsValidUser
									? <Trans i18nKey="homeTriage">
									Do you want to cancel the current triage ?
								</Trans> 
								: <Trans i18nKey="exitTriage">
									Are you sure you want to end triage?
								</Trans>
								}
							</label>
							<div className="pop_button">
								<button
									className="modal_yes"
									aria-label={(!state.isTriageGoingForRegularUser && !state.IsValidUser ? i18next.t("homeTriage") :i18next.t("exitTriage") )+" "+i18next.t("findcareoption.Yes")}
									onClick={(e) => {
										setState({
											showModal: false,
										});
										state.triageRequest.selectedCareOptionName = careOptions.ExitTriage;
										if (!state.IsOrgSubscriptionValid) {
											if (state.IsValidUser) {
												history.push({
													pathname: "/terms",
													search: "?organizationId=" + checkAndGetLocalStorageValue("orgid"),
												});
											}
											else if (state.isFacility) {
												history.push({
													pathname: "/find-facility",
													search: "?organizationId=" + checkAndGetLocalStorageValue("orgid"),
												});
											}
											else if (state.isTravelAid2) {
												history.push({
													pathname: "/triageNew",
													search: "?organizationId=" + checkAndGetLocalStorageValue("orgid"),
												});
											}
											else {
												history.push("/terms");
											}
										}
										else if (
											state.IsValidUser || state.isFacility || state.isTravelAid2 ||
											state.isTriageGoingForRegularUser
										) {
											history.push({
												pathname: "/find-care-options/thank-you",
												search: "?decline=1",
											});
											state.triageRequest.activeMenu = 'care-options'
											setState({ declineCare: true })

										} else {
											history.push("/terms");
										}
									}}
								>
									<Trans i18nKey="findcareoption.Yes">Yes</Trans>
								</button>
								<button
									className="modal_no"
									aria-label=	{(!state.isTriageGoingForRegularUser && !state.IsValidUser ? i18next.t("homeTriage") :i18next.t("exitTriage")) + " " + i18next.t("findcareoption.No")}
									onClick={(e) => {
										setState({
											showModal: false,
										});
									}}
								>
									<Trans i18nKey="findcareoption.No">No</Trans>
								</button>
							</div>
						</Modal>

					</div>
				),
				!state.IsValidUser && routeBase !== "" &&
				(!isLoggedIn ? (

					typeof window !== "undefined" ? (
						sessionStorage.getItem("IsValidUser") === "true" ||
							sessionStorage.getItem("isFacility") === "true" ||
							checkUrlSearchParamsHas(window.location.search) ? (
							""
						) : (
							<a
								key="login"
								href=""
								onClick={(e) => {
									e.preventDefault();
									actions.startAzureLogin();
								}}
							>
								<Trans i18nKey="Login">Login</Trans>
							</a>
						)
					) : (
						""
					)
				) : typeof window !== "undefined" ? (
					sessionStorage.getItem("IsValidUser") === "true" ||
						sessionStorage.getItem("isFacility") === "true" ||
						checkUrlSearchParamsHas(window.location.search) ? (
						""
					) : (
						<a
							key="logout"
							href=""
							onClick={(e) => {
								e.preventDefault();
								actions.azureLogout(actions, state, history);
							}}
						>
							<Trans i18nKey="Logout">Logout</Trans>
						</a>
					)
				) : (
					""
				)),
				<Modal
					isOpen={state.showLangModal}
					contentLabel="customStyles"
					className="ReactModal__Content_triagepopup"
					overlayClassName="ReactModal__Overlay_triagepopup"
					role=""
				>
					<label className="confirm_title">
						<Trans i18nKey="findcareoption.Careoptions.Please_confirm">
							Please confirm
						</Trans>
					</label>
					<label>
						{state.IsValidUser || isLoggedIn ? <Trans i18nKey="changeLanguageMsg">Do you want to change the language?</Trans> : <Trans i18nKey="changeLanguage"></Trans>}

					</label>

					<div className="pop_button">
						<button
						    aria-label= {(state.IsValidUser || isLoggedIn ? i18next.t("changeLanguageMsg") : i18next.t("changeLanguage")) + " " + i18next.t("findcareoption.Yes")}
							className="modal_yes"
							onClick={(e) => {
								{
									!isLoggedIn ? setState({
										isLoading: false,
										showLangModal: false,
									}) : setState({
										isLoading: true,
										showLangModal: false,
									})
								}

								i18n.changeLanguage(state.languageCode);
								if (typeof window !== "undefined") {
									window.sessionStorage.setItem("languageCode", state.languageCode);
									window.localStorage.setItem("privacy", null);
									window.localStorage.setItem("terms", null);
								}


								window.location.reload(false);
							}}
						>
							<Trans i18nKey="findcareoption.Yes">Yes</Trans>
						</button>
						<button
							aria-label= {(state.IsValidUser || isLoggedIn ? i18next.t("changeLanguageMsg") : i18next.t("changeLanguage")) + " " + i18next.t("findcareoption.No")}
							className="modal_no"
							onClick={(e) => {
								setState({
									isLoading: false,
									showLangModal: false,
								});
							}}
						>
							<Trans i18nKey="findcareoption.No">No</Trans>
						</button>
					</div>
				</Modal>
			],
		};

	if (Array.isArray(data)) data = { items: [...data] };
	if (data instanceof Function) data = data({ state, actions, location });

	const {
		title: menuTitle,
		items: menuItems,
		center: menuCenter,
		layout,
		footer,
	} = data;

	var dataItem;
	if(!state.showLangModal ){
	if( typeof window !== "undefined"){
		if (sessionStorage.getItem("IsValidUser") === "true" ||
			sessionStorage.getItem("isFacility") === "true" || sessionStorage.getItem("isTravelAid2") === "true" ||
			checkUrlSearchParamsHas(window.location.search))
		{
		const headerTitleCount = data.items.splice(-2)
	 	dataItem = data.items
		}	
	 	else{
			dataItem = menuItems
	 	}
	}else{
		const headerTitleCount = data.items.splice(-2)
	 	dataItem = data.items
		}
	}
	const result = {
		type: layout,
		menuTitle,
		menuItems: !state.showLangModal ?  dataItem : menuItems,
		menuCenter,
		footer,
	};
	// Only return keys with defined values
	return Object.keys(result).reduce((obj, key) => {
		if (result[key]) obj[key] = result[key];
		return obj;
	}, {});
};
